









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BaseCard>({})
export default class BaseCard extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    readonly isHighlighted!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    readonly noPad!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    readonly noOverflow!: boolean

    onClick() {
        this.$emit('click')
    }
}
